export default "__VITE_ASSET__CzvRMK9z__"